<template>
	
	<responsive-grid id="resp-grid" :search-results="true" root-scroll-container="search-scroll-container"
				v-bind:flyer-pages="flyerPages"></responsive-grid>
</template>

<script>
import GridComponent from "@/components/responsiveGrid.component.vue";

export default {
	name: "SearchResultFlyerView",
    components: {
		ResponsiveGrid: GridComponent,
    },
	props: [
    "flyerPages",
   ],
}
</script>